import { useState } from 'react'
import { ArrowRight, BookOpen, Sparkles } from 'lucide-react'
import { COVER_THEMES, PROJECT_TYPES } from '../data'
import { CoverArt, FieldLabel, ModalShell } from './Shared'

export default function NewProjectModal({ onClose, onCreate }) {
  const [title, setTitle] = useState('')
  const [subtitle, setSubtitle] = useState('')
  const [type, setType] = useState('长篇小说')
  const [theme, setTheme] = useState('forest')
  const [error, setError] = useState('')

  const preview = {
    title: title.trim() || '未命名笔记本',
    subtitle: subtitle.trim() || '一本刚刚开始的笔记本',
    type,
    theme,
    createdAt: new Date().toISOString(),
  }

  function submit(event) {
    event.preventDefault()
    if (!title.trim()) {
      setError('先给这本笔记一个名字吧。')
      return
    }
    onCreate({ title, subtitle, type, theme })
  }

  return (
    <ModalShell onClose={onClose} width="890px" className="new-project-modal">
      <div className="new-project-grid">
        <form className="new-project-form" onSubmit={submit}>
          <div className="modal-eyebrow"><BookOpen size={15} /> NEW NOTEBOOK / 新建笔记本</div>
          <h2>给下一个念头<br />留一本空册子。</h2>
          <p className="new-project-lead">它不必从第一页开始。先写一张卡片，剩下的交给时间和反复修改。</p>

          <FieldLabel hint="必填">笔记本名称</FieldLabel>
          <input
            className={'text-input text-input--title ' + (error ? 'has-error' : '')}
            value={title}
            onChange={(event) => { setTitle(event.target.value); setError('') }}
            placeholder="例如：潮汐之间"
            aria-label="笔记本名称"
            autoFocus
          />
          {error ? <div className="form-error">{error}</div> : null}

          <FieldLabel hint="可选">一句话描述</FieldLabel>
          <input
            className="text-input"
            value={subtitle}
            onChange={(event) => setSubtitle(event.target.value)}
            placeholder="这部作品，是关于什么的？"
            aria-label="笔记本描述"
          />

          <div className="form-row">
            <div>
              <FieldLabel>笔记本类型</FieldLabel>
              <div className="type-pills">
                {PROJECT_TYPES.slice(0, 4).map((item) => (
                  <button type="button" key={item} className={item === type ? 'pill active' : 'pill'} onClick={() => setType(item)}>{item}</button>
                ))}
              </div>
            </div>
            <div>
              <FieldLabel>封面</FieldLabel>
              <div className="theme-row">
                {COVER_THEMES.map((item) => (
                  <button
                    type="button"
                    key={item.id}
                    className={'swatch ' + (theme === item.id ? 'active' : '')}
                    style={{ '--swatch': item.swatch }}
                    onClick={() => setTheme(item.id)}
                    title={item.label}
                    aria-label={item.label}
                  >
                    <span />
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="new-project-hint">
            <Sparkles size={15} />
            <span>创建后会放入两张起步卡片，你可以随时拆分、合并，或邀请 AI 圆桌。</span>
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn--ghost" onClick={onClose}>取消</button>
            <button type="submit" className="btn btn--primary">开始装订 <ArrowRight size={16} /></button>
          </div>
        </form>

        <div className="new-project-preview">
          <div className="preview-grid" />
          <div className="preview-caption">封面预览 / FRONT COVER</div>
          <div className="preview-book">
            <CoverArt project={preview} variant="preview" />
          </div>
          <div className="preview-note">
            <span>01</span>
            <p>写下一句还没有想清楚的话，也没关系。</p>
          </div>
        </div>
      </div>
    </ModalShell>
  )
}
